export const QueueTreatmentActions = {
  DELETE: 'DELETE_QUEUE_TREATMENT',
  UPSERT: 'UPSERT_QUEUE_TREATMENT',
  GET: 'GET_QUEUE_TREATMENT',
  LIST_QUEUE_TREATMENT: 'LIST_QUEUE_TREATMENT',
  GET_AVAILABLE_HOURS: 'GET_AVAILABLE_HOURS',
  GET_QUEUES: 'GET_QUEUES',
  GET_FLOWS: 'GET_FLOWS',
  GET_PROMPTS: 'GET_PROMPTS',
  SET_CUSTOMER_QUEUE_FLOWS: 'SET_CUSTOMER_QUEUE_FLOWS',
  LOADING_QUEUE_TREATMENT: 'LOADING_QUEUE_TREATMENT',
  DELETING_QUEUE_TREATMENT: 'DELETING_QUEUE_TREATMENT',
  LIST_MENUS: 'LIST_MENUS',
  LOADING_MENUS: 'LOADING_MENUS',
  GET_NUMBERS: 'GET_NUMBERS',
  SET_AVAILABLE_NUMBERS: 'SET_AVAILABLE_NUMBERS',
  SET_AVAILABLE_CUSTOM_HOURS: 'SET_AVAILABLE_CUSTOM_HOURS',
  SET_MESSAGE: 'SET_MESSAGE',
  LOADING_QUEUE_FLOW_MAPPER: 'LOADING_QUEUE_FLOW_MAPPER',
  SET_QUEUE_FLOW_MAPPER: 'SET_QUEUE_FLOW_MAPPER',
};

export function queueTreatmentReducer(state: any, action: any) {
  switch (action.type) {
    case QueueTreatmentActions.DELETE: {
      // @todo Potentially remove queueTreatment from list instead of listing again
      return {
        ...state,
        deletingQueueTreatment: false,
      };
    }
    case QueueTreatmentActions.DELETING_QUEUE_TREATMENT: {
      // @todo Potentially remove queueTreatment from list instead of listing again
      return {
        ...state,
        deletingQueueTreatment: action.payload,
      };
    }
    case QueueTreatmentActions.UPSERT: {
      // @todo Potentially append queueTreatment in list instead of listing again
      return state;
    }
    case QueueTreatmentActions.GET: {
      // @todo append latest queueTreatment to list so the newest content is there in state
      return {
        ...state,
        workingQueueTreatment: action.payload.workingQueueTreatment,
      };
    }
    case QueueTreatmentActions.LOADING_QUEUE_TREATMENT: {
      return {
        ...state,
        loadingQueueTreatments: action.payload,
      };
    }
    case QueueTreatmentActions.LIST_QUEUE_TREATMENT: {
      return {
        ...state,
        queueTreatmentLoaded: true,
        loadingQueueTreatments: false,
        queueTreatmentList: action.payload.queueTreatmentList,
      };
    }
    case QueueTreatmentActions.GET_AVAILABLE_HOURS: {
      return {
        ...state,
        availableHoursLoaded: true,
        loadingAvailableHours: false,
        availableHours: action.payload.availableHours,
      };
    }
    case QueueTreatmentActions.GET_QUEUES:
      return {
        ...state,
        queuesLoaded: true,
        queues: action.payload.queues,
      };
    case QueueTreatmentActions.GET_FLOWS:
      return {
        ...state,
        flowsLoaded: true,
        flows: action.payload.flows,
      };
    case QueueTreatmentActions.GET_PROMPTS:
      return {
        ...state,
        promptsLoaded: true,
        prompts: action.payload.prompts,
      };
    case QueueTreatmentActions.SET_CUSTOMER_QUEUE_FLOWS:
      return {
        ...state,
        customerQueueFlows: action.payload.customerQueueFlows,
      };
    case QueueTreatmentActions.LIST_MENUS: {
      return {
        ...state,
        menusLoaded: true,
        menuList: action.payload.menuList,
      };
    }
    case QueueTreatmentActions.GET_NUMBERS:
      return {
        ...state,
        numbersLoaded: true,
        numbers: action.payload.numbers,
      };
    case QueueTreatmentActions.SET_AVAILABLE_NUMBERS:
      return {
        ...state,
        availableNumbers: action.payload,
      };
    case QueueTreatmentActions.SET_AVAILABLE_CUSTOM_HOURS:
      return {
        ...state,
        availableCustomHours: action.payload,
      };
    case QueueTreatmentActions.SET_MESSAGE:
      return {
        ...state,
        msg: action.payload.msg,
      };
    case QueueTreatmentActions.LOADING_QUEUE_FLOW_MAPPER: {
      return {
        ...state,
        loadingQueueFlowMapper: action.payload,
      };
    }
    case QueueTreatmentActions.SET_QUEUE_FLOW_MAPPER:
      return {
        ...state,
        queueFlowMapperLoaded: true,
        loadingQueueFlowMapper: false,
        queueFlowMapper: action.payload.queueFlowMapper,
      };
    default:
      return state;
  }
}
